import { RequestHandlingInstructionType } from "../../common/service/server/Types";
import { OrganizationDataRecipientDto } from "../../common/service/server/dto/OrganizationDataRecipientDto";
import {
  RequestHandlingInstructionDto,
  RequestHandlingInstructionEmbeddedDto,
} from "../../common/service/server/dto/RequestHandlingInstructionDto";
import { isNonSellingSharingThirdParty } from "./vendors";

const matchInstruction = (
  inst: RequestHandlingInstructionDto,
  orgId: string,
  vendorId: string,
  requestType: RequestHandlingInstructionType,
) => {
  return (
    orgId === inst.organizationId && vendorId === inst.vendorId && requestType === inst.requestType
  );
};

export const findInstruction = (
  instructions: RequestHandlingInstructionDto[],
  orgId: string,
  vendorId: string,
  requestType: RequestHandlingInstructionType,
) => {
  return instructions.find((inst) => {
    return matchInstruction(inst, orgId, vendorId, requestType);
  });
};

/**
 * When `doNotContact` is not explicitly for delete set on the instruction, and
 * its vendor has deletion instructions, default to true.
 */
export const shouldNotContactForDelete = (
  vendor: OrganizationDataRecipientDto,
  instruction: RequestHandlingInstructionDto | RequestHandlingInstructionEmbeddedDto,
): boolean => {
  if (isNonSellingSharingThirdParty(vendor)) {
    // With POL-6994, we allow adding internal storage locations to the contact workflow, even though storage locations are technically non-selling/non-sharing
    if (
      vendor.dataRecipientType === "storage_location" &&
      instruction &&
      instruction.doNotContact === false
    ) {
      return false;
    }

    return true;
  }
  return Boolean(instruction?.doNotContact == null && vendor?.deletionInstructions);
};
